import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import pdfIcon from 'assets/images/pdficon.png';
import PropTypes from 'prop-types';
import {
  DropZoneEmptyWrapper,
  DropZonePreviewItem,
  DropZonePreviewWrapper,
} from './DropZone.styled';
import { BaseError } from 'components/common/BaseError';

const maxSize = 10 * 1048576;

const styleDrapzone = {
  width: '100%',
  padding: '10px 0',
  border: '1px dashed rgba(100,78,2,.8)',
  backgroundColor: 'rgba(100,78,2,.1)',
  transition: 'border .24s ease-in-out',
  minHeight: '200px',
  display: 'flex',
  justifyContent: 'center',
};

const DropZone = ({ data, setData, multiple = false }) => {
  const [err, setErr] = useState('');

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles.length !== 0) {
        setErr('');
        const acceptedPaths = acceptedFiles.map((file) => file.path);
        // setData({
        //   names: acceptedPaths,
        //   files: acceptedFiles,
        // });
        setData((prev) => {
          if (prev === null) {
            return {
              names: acceptedPaths,
              files: acceptedFiles,
            };
          } else {
            if (multiple) {
              return {
                names: [...prev.names, ...acceptedPaths],
                files: [...prev.files, ...acceptedFiles],
              };
            } else {
              return {
                names: acceptedPaths,
                files: acceptedFiles,
              };
            }
          }
        });
      } else {
        setErr('File is larger than 10 Mb');
      }

      // if (!multiple) {
      //   // previewRef.current.src = URL.createObjectURL(acceptedFiles[0]);
      // } else {
      //   // acceptedFiles.forEach((file) => {
      //   //   const reader = new FileReader();
      //   //   reader.onabort = () => console.log("file reading was aborted");
      //   //   reader.onerror = () => console.log("file reading has failed");
      //   //   reader.onload = () => {
      //   //     const binaryStr = reader.result;
      //   //     setBase64Arr([binaryStr]);
      //   //   };
      //   //   reader.readAsDataURL(file);
      //   // });
      // }
    },
    [setData, multiple]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: multiple,
    accept: 'image/jpeg, image/png, application/pdf',
    minSize: 0,
    maxSize: maxSize,
    maxFiles: 3,
  });

  const deleteItem = useCallback(
    (index) => {
      const filteredFiles =
        data && data.files.filter((item, ind) => index !== ind);
      const filteredPaths =
        data && data.names.filter((item, ind) => index !== ind);
      if (filteredFiles.length === 0) {
        setData(null);
      } else {
        setData({
          names: filteredPaths,
          files: filteredFiles,
        });
      }
    },
    [data, setData]
  );

  return (
    <>
      <div {...getRootProps({ style: styleDrapzone })}>
        <input {...getInputProps()} />
        {data && data.length !== 0 ? (
          <DropZonePreviewWrapper>
            {data.files.map((item, index) => (
              <DropZonePreviewItem key={index}>
                <div>
                  <img
                    src={
                      data.length !== 0
                        ? item.type === 'application/pdf'
                          ? pdfIcon
                          : URL.createObjectURL(item)
                        : `#`
                    }
                    alt='Files'
                  />
                </div>

                <div>
                  <span>{data.names[index]}</span>
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      deleteItem(index);
                    }}
                  >
                    X
                  </span>
                </div>
              </DropZonePreviewItem>
            ))}
          </DropZonePreviewWrapper>
        ) : (
          <DropZoneEmptyWrapper>
            <div>
              <svg
                stroke='currentColor'
                fill='currentColor'
                strokeWidth='0'
                viewBox='0 0 24 24'
                height='1em'
                width='1em'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path d='M13 19L13 15 16 15 12 10 8 15 11 15 11 19z'></path>
                <path d='M7,19h2v-2H7c-1.654,0-3-1.346-3-3c0-1.404,1.199-2.756,2.673-3.015l0.581-0.102l0.192-0.558C8.149,8.274,9.895,7,12,7 c2.757,0,5,2.243,5,5v1h1c1.103,0,2,0.897,2,2s-0.897,2-2,2h-3v2h3c2.206,0,4-1.794,4-4c0-1.88-1.305-3.462-3.056-3.888 C18.507,7.67,15.56,5,12,5C9.244,5,6.85,6.611,5.757,9.15C3.609,9.792,2,11.82,2,14C2,16.757,4.243,19,7,19z'></path>
              </svg>
            </div>
            <p>
              <span>Choose files</span>
              or
              <span>Drag here</span>
            </p>
            <p className='filesize' style={{ textAlign: 'center' }}>
              Size limit: 10MB
            </p>
          </DropZoneEmptyWrapper>
        )}
      </div>
      {err && <BaseError>{err}</BaseError>}
    </>
  );
};

DropZone.propTypes = {
  data: PropTypes.object,
  setData: PropTypes.func,
  multiple: PropTypes.bool,
};

export default React.memo(DropZone);
